import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, shareReplay, switchMap } from 'rxjs';
import { TimezonesApiService } from './timezones-api.service';
import { BotTimezone } from './timezones.abstraction';

@Injectable({
    providedIn: 'root',
})
export class TimezonesService {
    #timezonesApiService = inject(TimezonesApiService);

    #update$ = new BehaviorSubject<void>(void 0);

    isLoading$ = this.#timezonesApiService.isLoading$;

    timezonesRes$ = this.#update$.pipe(
        switchMap(() => this.#timezonesApiService.getTimezones()),
        shareReplay(1),
    );

    timezones$: Observable<BotTimezone[]> = this.timezonesRes$.pipe(map(res => res.items));

    refresh(): void {
        this.#update$.next();
    }
}
